import React, { useCallback, useEffect, useState } from "react";
import MainLayout from "../components/MainLayout";
import { mainTable } from "../css/Common";
import InputText from "../ReusableComponents/InputText";
import { BindAPI, BindPostAPI } from "../services/APIConnection";
import { ProfileCATClientsReportHeader } from "../components/HeaderAttribute";
import * as XLSX from "sheetjs-style";
import jsPDF from "jspdf";
import "jspdf-autotable";
import fpaiLogo from "../image/FPAILogo.jpg";
import MultiSelect from "../ReusableComponents/MultiSelect";
import ReportRowRowPage from "../components/ReportGridRowPage";
import { useUserCapability } from "../components/ConstantReducerProvider";
import AutoDropDown from "../ReusableComponents/AutoCompleteDropDown";

const ProfileCATClientsReport = () => {
  const { userProfileState } = useUserCapability();
  const userProfileDatas = userProfileState.userProfile;
  const [branchProject, setBranchProject] = useState("");
  const [branchName, setBranchName] = useState("");
  const [sdp, setSDP] = useState("");
  const [branchProjectError, setBranchProjectError] = useState("");
  const [sdpError, setSDPError] = useState("");
  const [area, setArea] = useState("");
  const [areaError, setAreaError] = useState("");
  const [bindBranchProjectDD, setBindBranchProjectDD] = useState([]);
  const [bindProfileCATClientsData, setBindProfileCATClientsData] = useState(
    []
  );
  const [showTable, setShowTable] = useState(false);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [getSDPDatas, setGetSDPDatas] = useState([]);
  const [bindSDP, setBindSDP] = useState([]);

  const [project, setProject] = useState(0);
  const [projectError, setProjectError] = useState("");
  const [bindProject, setBindProject] = useState([]);
  const [getAreaDatas, setGetAreaDatas] = useState([]);
  const [bindArea, setBindAreaDD] = useState([]);

  const [branchProjectNamesList, setBranchProjectNamesList] = useState([]);
  const [sdpNamesList, setSDPNamesList] = useState([]);
  const [areaNamesList, setAreaNamesList] = useState([]);

  useEffect(
    () => {
      if (branchProject) {
        try {
          const getSelectedSDP = async () => {
            const locationResponse = await BindAPI("SDPAPI/GetSDP");
            setGetSDPDatas(locationResponse.data.Table);

            if (userProfileDatas && userProfileDatas[0]) {
              const sdpLabels = locationResponse.data.Table.filter((item) =>
                branchProject.includes(parseInt(item.MstLocationId))
              ).map((item) => ({
                MstSDPId: item.MstSDPId,
                SDP_en: item.SDP_en,
              }));

              const sdpSelected = sdpLabels.map((SD) => ({
                value: SD.MstSDPId,
                label: SD.SDP_en,
              }));

              if (
                userProfileDatas[0].MstOrganizationId == 1 ||
                userProfileDatas[0].MstOrganizationId == 2
              ) {
                setBindSDP(sdpSelected);
              } else {
                const allSDPIds = userProfileDatas[0]?.AllSDP;
                const sdpId = userProfileDatas[0]?.MstSDPId;

                if (allSDPIds && Array.isArray(allSDPIds)) {
                  const filteredSdpSelected = sdpSelected.filter((sdp) =>
                    allSDPIds.includes(sdp.value)
                  );
                  setBindSDP(filteredSdpSelected);
                }
                if (sdpId) {
                  setBindSDP([]);
                  const filteredSdpSelected = sdpSelected.filter((sdp) =>
                    Array.isArray(sdpId)
                      ? sdpId.includes(sdp.value)
                      : sdpId === sdp.value
                  );
                  setBindSDP(filteredSdpSelected);
                }
              }
            }
          };

          getSelectedSDP();
        } catch (e) {
        }
      }
    },
    [branchProject ? branchProject : undefined],
    userProfileDatas ? userProfileDatas : undefined
  );
  useEffect(() => {
    if (sdp) {
      try {
        const getSelectedArea = async () => {
          const locationResponse = await BindAPI("AreaAPI/GetArea");
          setGetAreaDatas(locationResponse.data.Table);

          const areaLabels = locationResponse.data.Table.filter((item) =>
            sdp.includes(item.MstSDPId)
          ).map((item) => ({
            MstAreaId: item.MstAreaId,
            AreaName_en: item.AreaName_en,
          }));

          const areaSelected = areaLabels.map((AR) => ({
            value: AR.MstAreaId,
            label: AR.AreaName_en,
          }));

          setBindAreaDD(areaSelected);
        };

        getSelectedArea();
      } catch (e) {
      }
    }
  }, [sdp ? sdp : undefined]);

  useEffect(() => {
    if (
      userProfileDatas[0]?.MstOrganizationId == 2 ||
      userProfileDatas[0]?.MstOrganizationId == 3
    ) {
      if (userProfileDatas[0]?.MstSDPId == null) {
        setBranchName(userProfileDatas[0]?.LocationName_en);
        setBranchProject([userProfileDatas[0]?.MstLocationId]);
        setSDP("");
      } else {
        setBranchName(userProfileDatas[0]?.LocationName_en);
        setBranchProject([userProfileDatas[0]?.MstLocationId]);
        setSDP([userProfileDatas[0]?.MstSDPId]);
      }
    }
    BranchProjectFetchData();
  }, [userProfileDatas ? userProfileDatas : undefined]);

  const GoButton = async () => {
    const branchProjectValidate = branchProject ? "" : "Select Branch/Project";
    setBranchProjectError(branchProjectValidate);

    const sdpValidate = sdp ? "" : "Select SDP";
    setSDPError(sdpValidate);

    const areaValidate = area ? "" : "Select Area";
    setAreaError(areaValidate);

    let branchArray = Array.from(
      { length: branchProject.length },
      (v, i) => branchProject[i]
    );
    let branchResult = branchArray.join(",");

    let sdpArray = Array.from({ length: sdp.length }, (v, i) => sdp[i]);
    let sdpResult = sdpArray.join(",");

    let areaArray = Array.from({ length: area.length }, (v, i) => area[i]);
    let areaResult = areaArray.join(",");

    if (!branchProjectValidate && !sdpValidate && !areaValidate) {
      const ReportData = [
        {
          mstBranchId: branchResult,
          mstSDPId: sdpResult,
          mstAreaId: areaResult,
          mstProjectId: project ?? 0,
          fromDate: fromDate,
          toDate: toDate,
        },
      ];
      const response = await BindPostAPI(
        ReportData,
        "ClientAPI/ReportProfileCATClients"
      );

      setBindProfileCATClientsData(response.data.Table);
      setShowTable(true);
    } else {
    }
  };
  useEffect(() => {
    const today = new Date();
    const currentYear = today.getFullYear();
    const automaticFromDate = `${currentYear}-01-01`;
    setFromDate(automaticFromDate);

    const formattedToDate = today.toISOString().split("T")[0];
    setToDate(formattedToDate);

    fetchAllDropdowns();
  }, []);

  const getBranchProjectsNames = (updatedOptions) => {
    const NameList = updatedOptions
      .map(
        (option) =>
          bindBranchProjectDD?.find((item) => item.value === option)?.label
      )
      .filter(Boolean); // Remove undefined values if any

    return NameList;
  };

  const handleExport = () => {
    const dateRange = {
      fromDate: fromDate,
      toDate: toDate,
    };

    const selectedOptionsData = {
      branchProjectData:
        branchProjectNamesList.length > 0
          ? branchProjectNamesList.toString()
          : branchName,
      sdpData: sdpNamesList.toString(),
      areaData: areaNamesList.toString(),
    };
    exportData(
      ProfileCATClientsReportHeader.map((column) => column.title),
      bindProfileCATClientsData,
      dateRange,
      selectedOptionsData
    );
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    const date = new Date(dateStr);
    return `${date.getDate().toString().padStart(2, "0")}-${(
      date.getMonth() + 1
    )
      .toString()
      .padStart(2, "0")}-${date.getFullYear()}`;
  };
  const exportData = (columns, rows, dateRange, selectedDetails) => {
    const COL = {
      SNO: 0,
      BRANCH: 1,
      SDP: 2,
      AREA: 3,
      PROJECT: 4,
      CATEGORY: 5,
      GENDER: 6,
      AGE_START: 7,
    };

    /* ---------------- TITLE ---------------- */
    const titleRow = [
      {
        v: "Profile CAT Clients Category Wise Report",
        s: {
          font: { bold: true, sz: 16 },
          alignment: { horizontal: "center" },
        },
      },
    ];

    /* ---------------- DATE RANGE ---------------- */
    const dateRangeRow = [
      { v: "" },
      { v: "From Date:", s: { font: { bold: true } } },
      { v: formatDate(dateRange.fromDate) },
      { v: "To Date:", s: { font: { bold: true } } },
      { v: formatDate(dateRange.toDate) },
    ];

    /* ---------------- FILTER DETAILS ---------------- */
    const branchRow = [
      { v: "" },
      { v: "Branch/Project:", s: { font: { bold: true } } },
      { v: selectedDetails.branchProjectData },
      { v: "S.D.P.:", s: { font: { bold: true } } },
      { v: selectedDetails.sdpData },
      { v: "Area:", s: { font: { bold: true } } },
      { v: selectedDetails.areaData },
    ];

    const spacingRow = [{ v: "" }];

    /* ---------------- HEADER ---------------- */
    const headerRow = [
      ...columns.map((column) => ({
        v: column,
        s: {
          fill: { fgColor: { rgb: "2D2D6E" } },
          font: { bold: true, color: { rgb: "FFFFFF" } },
          alignment: { horizontal: "center" },
        },
      })),
      {
        v: "Total",
        s: {
          fill: { fgColor: { rgb: "2D2D6E" } },
          font: { bold: true, color: { rgb: "FFFFFF" } },
          alignment: { horizontal: "center" },
        },
      },
    ];

    const baseStyle = { alignment: { horizontal: "right" }, numFmt: "0" };

    /* ---------------- DATA ROWS ---------------- */
    const transformedData = rows.flatMap((rowData, index) => {
      const rowStyle = {
        fill: { fgColor: { rgb: index % 2 ? "F0F0F0" : "FFFFFF" } },
      };

      const num = (v) => Number(v || 0);
      const cell = (v) => ({ v: num(v), t: "n", s: { ...baseStyle, ...rowStyle } });

      const ageSum = (prefix) =>
        num(rowData[`${prefix}Age0to9`]) +
        num(rowData[`${prefix}Age10to14`]) +
        num(rowData[`${prefix}Age15to19`]) +
        num(rowData[`${prefix}Age20to24`]) +
        num(rowData[`${prefix}Age25to29`]) +
        num(rowData[`${prefix}Age30to34`]) +
        num(rowData[`${prefix}Age35to39`]) +
        num(rowData[`${prefix}Age40to44`]) +
        num(rowData[`${prefix}Age45to49`]) +
        num(rowData[`${prefix}Age50andAbove`]);

      const makeRow = (gender, prefix, showMain) => [
        showMain ? { v: index + 1, s: rowStyle } : { v: "", s: rowStyle },
        showMain ? { v: rowData.Branch, s: rowStyle } : { v: "", s: rowStyle },
        showMain ? { v: rowData.SDP, s: rowStyle } : { v: "", s: rowStyle },
        showMain ? { v: rowData.Area, s: rowStyle } : { v: "", s: rowStyle },
        showMain ? { v: rowData.Project, s: rowStyle } : { v: "", s: rowStyle },
        showMain ? { v: rowData.ServicesCategory_en, s: rowStyle } : { v: "", s: rowStyle },
        { v: gender, s: rowStyle },

        cell(rowData[`${prefix}Age0to9`]),
        cell(rowData[`${prefix}Age10to14`]),
        cell(rowData[`${prefix}Age15to19`]),
        cell(rowData[`${prefix}Age20to24`]),
        cell(rowData[`${prefix}Age25to29`]),
        cell(rowData[`${prefix}Age30to34`]),
        cell(rowData[`${prefix}Age35to39`]),
        cell(rowData[`${prefix}Age40to44`]),
        cell(rowData[`${prefix}Age45to49`]),
        cell(rowData[`${prefix}Age50andAbove`]),

        cell(ageSum(prefix)),
      ];

      return [
        makeRow("Male", "Male", true),
        makeRow("Female", "Female", false),
        makeRow("Other", "Other", false),
      ];
    });

    /* ---------------- COLUMN TOTALS ---------------- */
    const columnTotals = [
      { v: "", s: { font: { bold: true } } },
      { v: "Total", s: { font: { bold: true } } },
      ...Array(COL.GENDER - 1).fill({ v: "", s: { font: { bold: true } } }),
    ];

    for (let c = COL.AGE_START; c < headerRow.length - 1; c++) {
      columnTotals.push({
        v: transformedData.reduce((s, r) => s + (r[c]?.v || 0), 0),
        t: "n",
        s: { ...baseStyle, font: { bold: true } },
      });
    }

    columnTotals.push({
      v: transformedData.reduce(
        (s, r) => s + (r[r.length - 1]?.v || 0),
        0
      ),
      t: "n",
      s: { ...baseStyle, font: { bold: true } },
    });

    /* ---------------- WORKSHEET ---------------- */
    const wsData = [
      titleRow,
      dateRangeRow,
      branchRow,
      spacingRow,
      headerRow,
      ...transformedData,
      columnTotals,
    ];

    const ws = XLSX.utils.aoa_to_sheet(wsData);

    ws["!merges"] = [{ s: { r: 0, c: 0 }, e: { r: 0, c: headerRow.length - 1 } }];

    ws["!cols"] = [
      { wch: 8 },
      { wch: 20 },
      { wch: 20 },
      { wch: 20 },
      { wch: 20 },
      { wch: 30 },
      { wch: 12 },
      ...Array(10).fill({ wch: 12 }),
      { wch: 15 },
    ];

    const range = XLSX.utils.decode_range(ws["!ref"]);
    for (let R = range.s.r; R <= range.e.r; R++) {
      for (let C = range.s.c; C <= range.e.c; C++) {
        const ref = XLSX.utils.encode_cell({ r: R, c: C });
        if (!ws[ref]) continue;
        ws[ref].s = {
          ...ws[ref].s,
          border: {
            top: { style: "thin" },
            bottom: { style: "thin" },
            left: { style: "thin" },
            right: { style: "thin" },
          },
        };
      }
    }

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Profile CAT Clients");
    XLSX.writeFile(wb, "Profile_CAT_clients_category_wise_report.xlsx");
  };

  // const exportData = (columns, rows, dateRange, selectedDetails) => {
  //   // Title row
  //   const titleRow = [
  //     {
  //       v: "Profile CAT Clients Category Wise Report",
  //       s: {
  //         font: { bold: true, sz: 16 },
  //         alignment: { horizontal: "center" },
  //       },
  //     },
  //   ];

  //   // Date range row with merged cells
  //   const dateRangeRow = [
  //     { v: "" },
  //     {
  //       v: "From Date:",
  //       s: {
  //         font: { bold: true },
  //         alignment: { horizontal: "right" },
  //       },
  //     },
  //     {
  //       v: formatDate(dateRange.fromDate),
  //       s: {
  //         alignment: { horizontal: "left" },
  //       },
  //     },
  //     {
  //       v: "To Date:",
  //       s: {
  //         font: { bold: true },
  //         alignment: { horizontal: "left" },
  //       },
  //     },
  //     {
  //       v: formatDate(dateRange.toDate),
  //       s: {
  //         alignment: { horizontal: "left" },
  //       },
  //     },
  //   ];

  //   // Branch information row with merged cells
  //   const branchRow = [
  //     { v: "" },

  //     {
  //       v: "Branch/Project:",
  //       s: {
  //         font: { bold: true },
  //         alignment: { horizontal: "right" },
  //       },
  //     },
  //     {
  //       v: selectedDetails.branchProjectData,
  //       s: {
  //         alignment: { horizontal: "left" },
  //         alignment: { wrapText: true }, // Enable text wrapping
  //       },
  //     },

  //     {
  //       v: "S.D.P.:",
  //       s: {
  //         font: { bold: true },
  //         alignment: { horizontal: "right" },
  //       },
  //     },
  //     {
  //       v: selectedDetails.sdpData,
  //       s: {
  //         alignment: { horizontal: "left" },
  //         alignment: { wrapText: true }, // Enable text wrapping
  //       },
  //     },

  //     {
  //       v: "Area:",
  //       s: {
  //         font: { bold: true },
  //         alignment: { horizontal: "right" },
  //       },
  //     },
  //     {
  //       v: selectedDetails.areaData,
  //       s: {
  //         alignment: { horizontal: "left" },
  //         alignment: { wrapText: true }, // Enable text wrapping
  //       },
  //     },
  //   ];

  //   // Add empty row for spacing
  //   const spacingRow = [{ v: "" }];

  //   // Header row with styles
  //   const headerRow = [
  //     ...columns.map((column) => ({
  //       v: column,
  //       s: {
  //         fill: { fgColor: { rgb: "2D2D6E" } },
  //         font: { bold: true, color: { rgb: "FFFFFF" } },
  //         alignment: { horizontal: "left" },
  //       },
  //     })),
  //     {
  //       v: "Total",
  //       s: {
  //         fill: { fgColor: { rgb: "2D2D6E" } },
  //         font: { bold: true, color: { rgb: "FFFFFF" } },
  //         alignment: { horizontal: "right" },
  //       },
  //     },
  //   ];

  //   const baseStyle = {
  //     alignment: { horizontal: "right" },
  //     numFmt: "0",
  //   };

  //   const transformedData = rows.flatMap((rowData, index) => {
  //     const rowStyle = {
  //       fill: { fgColor: { rgb: index % 2 === 1 ? "F0F0F0" : "FFFFFF" } },
  //     };

  //     const formatCell = (value) => ({
  //       v: Number(value || 0),
  //       t: "n",
  //       s: { ...baseStyle, ...rowStyle },
  //     });

  //     const maleRow = [
  //       { v: index + 1, s: rowStyle },
  //       { v: rowData.Branch, s: rowStyle },
  //       { v: rowData.SDP, s: rowStyle },
  //       { v: rowData.Area, s: rowStyle },

  //       { v: rowData.Project, s: rowStyle },
  //       { v: rowData.ServicesCategory_en, s: rowStyle },
  //       { v: "Male", s: rowStyle },
  //       formatCell(rowData.MaleAge0to9),
  //       formatCell(rowData.MaleAge10to14),
  //       formatCell(rowData.MaleAge15to19),
  //       formatCell(rowData.MaleAge20to24),
  //       formatCell(rowData.MaleAge25to29),
  //       formatCell(rowData.MaleAge30to34),
  //       formatCell(rowData.MaleAge35to39),
  //       formatCell(rowData.MaleAge40to44),
  //       formatCell(rowData.MaleAge45to49),
  //       formatCell(rowData.MaleAge50andAbove),
  //       formatCell(
  //         rowData.MaleAge0to9 +
  //         rowData.MaleAge10to14 +
  //         rowData.MaleAge15to19 +
  //         rowData.MaleAge20to24 +
  //         rowData.MaleAge25to29 +
  //         rowData.MaleAge30to34 +
  //         rowData.MaleAge35to39 +
  //         rowData.MaleAge40to44 +
  //         rowData.MaleAge45to49 +
  //         rowData.MaleAge50andAbove
  //       ),
  //     ];

  //     const femaleRow = [
  //       { v: "", s: rowStyle },
  //       { v: "", s: rowStyle },
  //       { v: "", s: rowStyle },

  //       { v: "", s: rowStyle },
  //       { v: "", s: rowStyle },
  //       { v: "", s: rowStyle },
  //       { v: "Female", s: rowStyle },
  //       formatCell(rowData.FemaleAge0to9),
  //       formatCell(rowData.FemaleAge10to14),
  //       formatCell(rowData.FemaleAge15to19),
  //       formatCell(rowData.FemaleAge20to24),
  //       formatCell(rowData.FemaleAge25to29),
  //       formatCell(rowData.FemaleAge30to34),
  //       formatCell(rowData.FemaleAge35to39),
  //       formatCell(rowData.FemaleAge40to44),
  //       formatCell(rowData.FemaleAge45to49),
  //       formatCell(rowData.FemaleAge50andAbove),
  //       formatCell(
  //         rowData.FemaleAge0to9 +
  //         rowData.FemaleAge10to14 +
  //         rowData.FemaleAge15to19 +
  //         rowData.FemaleAge20to24 +
  //         rowData.FemaleAge25to29 +
  //         rowData.FemaleAge30to34 +
  //         rowData.FemaleAge35to39 +
  //         rowData.FemaleAge40to44 +
  //         rowData.FemaleAge45to49 +
  //         rowData.FemaleAge50andAbove
  //       ),
  //     ];

  //     const otherRow = [
  //       { v: "", s: rowStyle },
  //       { v: "", s: rowStyle },
  //       { v: "", s: rowStyle },
  //       { v: "", s: rowStyle },
  //       { v: "", s: rowStyle },
  //       { v: "Other", s: rowStyle },
  //       formatCell(rowData.OtherAge0to9),
  //       formatCell(rowData.OtherAge10to14),
  //       formatCell(rowData.OtherAge15to19),
  //       formatCell(rowData.OtherAge20to24),
  //       formatCell(rowData.OtherAge25to29),
  //       formatCell(rowData.OtherAge30to34),
  //       formatCell(rowData.OtherAge35to39),
  //       formatCell(rowData.OtherAge40to44),
  //       formatCell(rowData.OtherAge45to49),
  //       formatCell(rowData.OtherAge50andAbove),
  //       formatCell(
  //         rowData.OtherAge0to9 +
  //         rowData.OtherAge10to14 +
  //         rowData.OtherAge15to19 +
  //         rowData.OtherAge20to24 +
  //         rowData.OtherAge25to29 +
  //         rowData.OtherAge30to34 +
  //         rowData.OtherAge35to39 +
  //         rowData.OtherAge40to44 +
  //         rowData.OtherAge45to49 +
  //         rowData.OtherAge50andAbove
  //       ),
  //     ];

  //     return [maleRow, femaleRow, otherRow];
  //   });


  //   // Add column totals
  //   const columnTotals = [
  //     { v: "", s: { font: { bold: true } } },
  //     { v: "Total", s: { font: { bold: true } } },
  //     { v: "", s: { font: { bold: true } } },
  //     { v: "", s: { font: { bold: true } } },
  //   ];
  //   for (let i = 4; i < headerRow.length - 1; i++) {
  //     const columnSum = transformedData.reduce(
  //       (sum, row) => sum + (row[i]?.v || 0),
  //       0
  //     );
  //     columnTotals.push({
  //       v: columnSum,
  //       t: "n",
  //       s: { ...baseStyle, font: { bold: true } },
  //     });
  //   }

  //   // Add the total of totals column
  //   // Add the total of the last column (row totals column)
  //   const lastColumnTotal = transformedData.reduce((sum, row) => {
  //     // Get the last column value (row total)
  //     const rowTotal = row[row.length - 1]?.v || 0;
  //     return sum + rowTotal;
  //   }, 0);

  //   columnTotals.push({
  //     v: lastColumnTotal,
  //     t: "n",
  //     s: { ...baseStyle, font: { bold: true } },
  //   });

  //   // Create worksheet and add borders
  //   const wsData = [
  //     titleRow,
  //     dateRangeRow,
  //     branchRow,
  //     spacingRow,
  //     headerRow,
  //     ...transformedData,
  //     columnTotals,
  //   ];
  //   const ws = XLSX.utils.aoa_to_sheet(wsData);

  //   ws["!merges"] = [
  //     //   // Merge title cell across columns
  //     { s: { r: 0, c: 0 }, e: { r: 0, c: 4 } },
  //   ];

  //   // Set column widths
  //   ws["!cols"] = [
  //     { wch: 10 }, // Adjust column width for the first column
  //     { wch: 25 }, // Adjust column width for the second column
  //     { wch: 15 }, // Adjust width for the "Gender" column
  //     { wch: 15 },
  //     ...new Array(columns.length - 4).fill({ wch: 10 }), // Set other columns to 10
  //     { wch: 15 }, // Width for the "Row Total" column
  //   ];

  //   // Set row heights for wrapped content
  //   ws["!rows"] = [
  //     { hpt: 30 }, // Title row height
  //     { hpt: 15 }, // Date range row height
  //     { hpt: 15 }, // Branch row height (taller for wrapped content)
  //     { hpt: 15 }, // Spacing row height
  //     { hpt: 15 }, // Header row height (taller for wrapped content)
  //     ...Array(rows.length).fill({ hpt: 15 }), // Data rows height
  //     { hpt: 15 }, // Totals row height
  //   ];

  //   // Apply borders and styles
  //   const applyStyles = (ws) => {
  //     const range = XLSX.utils.decode_range(ws["!ref"]);
  //     for (let R = range.s.r; R <= range.e.r; R++) {
  //       for (let C = range.s.c; C <= range.e.c; C++) {
  //         const cellRef = XLSX.utils.encode_cell({ r: R, c: C });
  //         if (!ws[cellRef]) continue;

  //         // Add borders to all cells
  //         ws[cellRef].s = {
  //           ...ws[cellRef].s,
  //           border: {
  //             top: { style: "thin", color: { rgb: "000000" } },
  //             bottom: { style: "thin", color: { rgb: "000000" } },
  //             left: { style: "thin", color: { rgb: "000000" } },
  //             right: { style: "thin", color: { rgb: "000000" } },
  //           },
  //         };
  //       }
  //     }
  //   };

  //   applyStyles(ws);

  //   const wb = XLSX.utils.book_new();
  //   XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

  //   XLSX.writeFile(wb, "Profile_CAT_clients_category_wise_report.xlsx");
  // };

  const downloadPDF = () => {
    const doc = new jsPDF("landscape"); // Use landscape orientation for more horizontal space
    const logoWidth = 30;
    const logoHeight = 14;
    doc.addImage(fpaiLogo, "JPEG", 10, 10, logoWidth, logoHeight);

    // Ensure ProfileCATClientsReportHeader is an array of objects with a title property
    const headers = ProfileCATClientsReportHeader.map((column) => column.title);

    // Map bindProfileCATClientsData to the appropriate format for autoTable
    const data = bindProfileCATClientsData.flatMap((rowData, index) => {
      return [
        [
          { content: index + 1, rowSpan: 3 },
          { content: rowData.Branch, rowSpan: 3 },

          { content: rowData.ServicesCategory_en, rowSpan: 3 },
          "Male",
          rowData.MaleAge0to9,
          rowData.MaleAge10to14,
          rowData.MaleAge15to19,
          rowData.MaleAge20to24,
          rowData.MaleAge25to29,
          rowData.MaleAge30to34,
          rowData.MaleAge35to39,
          rowData.MaleAge40to44,
          rowData.MaleAge45to49,
          rowData.MaleAge50andAbove,
        ],
        [
          "Female",
          rowData.FemaleAge0to9,
          rowData.FemaleAge10to14,
          rowData.FemaleAge15to19,
          rowData.FemaleAge20to24,
          rowData.FemaleAge25to29,
          rowData.FemaleAge30to34,
          rowData.FemaleAge35to39,
          rowData.FemaleAge40to44,
          rowData.FemaleAge45to49,
          rowData.FemaleAge50andAbove,
        ],
        [
          "Other",
          rowData.OtherAge0to9,
          rowData.OtherAge10to14,
          rowData.OtherAge15to19,
          rowData.OtherAge20to24,
          rowData.OtherAge25to29,
          rowData.OtherAge30to34,
          rowData.OtherAge35to39,
          rowData.OtherAge40to44,
          rowData.OtherAge45to49,
          rowData.OtherAge50andAbove,
        ],
      ];
    });

    // Create the table with headers and data
    doc.autoTable({
      head: [headers],
      body: data,
      startY: 30,
      styles: {
        fontSize: 7, // Reduced font size
        lineColor: "black",
        lineWidth: 0.2,
        halign: "center", // Align text to center
        valign: "middle", // Align text vertically in the middle
        cellPadding: 2, // Add padding to cells
        overflow: "linebreak", // Allow text to wrap within cells
      },
      headStyles: {
        fillColor: "#2d2d6e",
        textColor: [255, 255, 255],
      },
      alternateRowStyles: {
        fillColor: [240, 240, 240], // Light gray color for alternate rows
      },
      columnStyles: {
        0: { cellWidth: 10 }, // Index column
        1: { cellWidth: "auto" }, // Auto adjust width
        2: { cellWidth: "auto" }, // Auto adjust width
        3: { cellWidth: "auto" }, // Auto adjust width
        4: { cellWidth: "auto" }, // Auto adjust width
        5: { cellWidth: "auto" }, // Auto adjust width
        6: { cellWidth: "auto" }, // Auto adjust width
        7: { cellWidth: "auto" }, // Auto adjust width
        8: { cellWidth: "auto" }, // Auto adjust width
        9: { cellWidth: "auto" }, // Auto adjust width
        10: { cellWidth: 15 }, // Age
        11: { cellWidth: 15 }, // Gender
        12: { cellWidth: "auto" }, // Auto adjust width
        13: { cellWidth: "auto" }, // Auto adjust width
        14: { cellWidth: "auto" }, // Auto adjust width
        15: { cellWidth: "auto" }, // Auto adjust width
        16: { cellWidth: "auto" }, // Auto adjust width
      },
    });

    doc.save("Profile_CAT clients  category wise clients.pdf");
  };

  const BranchProjectFetchData = async () => {
    try {
      const locationResponse = await BindAPI("LocationAPI/GetLocation");

      const locationData = locationResponse.data.Table.map((item) => ({
        value: item.MstLocationId,
        label: item.LocationName_en,
      }));

      setBindBranchProjectDD(locationData);
    } catch (error) { }
  };

  const sdpChange = (updatedOptions) => {
    setArea("");
    setShowTable(false);
    setSDP(updatedOptions);
    setBindAreaDD([]);
    const SDPlabels = getSDPNames(updatedOptions);
    setSDPNamesList(SDPlabels);
  };

  const getSDPNames = (updatedOptions) => {
    const NameList = updatedOptions
      .map((option) => bindSDP?.find((item) => item.value === option)?.label)
      .filter(Boolean); // Remove undefined values if any

    return NameList;
  };

  const brangeChange = (updatedOptions) => {
    setSDP("");
    setShowTable(false);
    setArea("");
    setBindSDP([]);
    setBindAreaDD([]);
    setBranchProject(updatedOptions);

    const branchProjectlabels = getBranchProjectsNames(updatedOptions);
    setBranchProjectNamesList(branchProjectlabels);
  };
  const areaChange = (updatedOptions) => {
    setArea("");
    setShowTable(false);
    setArea(updatedOptions);
    const arealabels = getAreaNames(updatedOptions);
    setAreaNamesList(arealabels);
  };

  const getAreaNames = (updatedOptions) => {
    const NameList = updatedOptions
      .map((option) => bindArea?.find((item) => item.value === option)?.label)
      .filter(Boolean); // Remove undefined values if any

    return NameList;
  };

  const fetchAllDropdowns = useCallback(async () => {

    try {
      // 🔹 Run APIs in parallel
      const [locationRes, pacServicesRes] = await Promise.all([
        BindAPI("TXNServicesAPI/ServicesDatas"),
        BindAPI("ServicesMasterAPI/BindServicesDropDowns"),
      ]);

      const locData = locationRes.data || {};
      const pacData = pacServicesRes.data || {};

      // 🔹 Extract tables once
      const tables = {
        location: locData.Table2 ?? [],
        area: locData.Table ?? [],
        brand: locData.Table6 ?? [],
        serviceSub: locData.Table5 ?? [],
        services: locData.Table9 ?? [],
        project: locData.Table3 ?? [],
        serviceCategory: locData.Table4 ?? [],
        referredTo: locData.Table8 ?? [],
        pacServices: pacData.Table1 ?? [],
        appointmentWith: locData.Table1 ?? [],
      };

      // 🔹 Filter project by MstBranchProjectId & user organization
      const userOrgId = userProfileDatas[0]?.MstLocationId;

      tables.project = tables.project.filter(
        (item) => item.MstBranchProjectId === userOrgId
      );

      // 🔹 Reusable mapper
      const toOptions = (arr = [], valueKey, labelKey, { filterBlocked = false } = {}) =>
        arr
          .filter(item => !filterBlocked || item.BlockedBy == null)
          .map(item => ({ value: item[valueKey], label: item[labelKey] }));

      // 🔹 Prepare dropdowns
      const dropdowns = {
        bindSDPDD: toOptions(tables.appointmentWith, "MstSDPId", "SDP_en"),
        bindArea: toOptions(tables.area, "MstAreaId", "AreaName_en"),
        bindProject: toOptions(tables.project, "MstProjectId", "ProjectName_en"),
        bindServiceCategory: toOptions(
          tables.serviceCategory,
          "MstServicesCategoryId",
          "ServicesCategory_en"
        ),
        bindReferralDD: toOptions(tables.referredTo, "MstReferredToId", "ReferredTo_en"),
        bindPACServices: toOptions(tables.pacServices, "MstPACServicesId", "PACServices"),
      };

      // 🔹 User-specific SDP dropdown
      const { MstSDPId: userSDPId, MstLocationId: userLocationId } = userProfileDatas[0] || {};
      dropdowns.bindUserSDPDD = tables.appointmentWith
        .filter(item =>
          userSDPId ? item.MstSDPId == userSDPId : item.MstLocationId == userLocationId
        )
        .map(item => ({ value: item.MstSDPId, label: item.SDP_en }));

      setBindProject(dropdowns.bindProject);
    } catch (err) {
      console.error("Error fetching dropdown data:", err);
    } finally {
    }
  }, [userProfileDatas]);



  return (
    <MainLayout pageName="4">
      <div>
        <div class="relative m-3 bg-white rounded-lg ">
          <div class="mt-3 py-4">
            <div className={mainTable.headerTitle}>
              <div className="my-2 mx-12 lg:mx-0">{`Profile_CAT clients  category wise clients`}</div>
            </div>
            <div className={mainTable.grid3}>
              {userProfileDatas[0]?.MstOrganizationId == 1 && (
                <div>
                  <MultiSelect
                    classStar="text-red-500"
                    label="Branch/Project"
                    filteredOptions={bindBranchProjectDD}
                    classFilterLabel="p-1 flex gap-1"
                    class="custom-class"
                    placeholder={
                      branchProject?.length > 0 ? "More Selected" : "Select..."
                    }
                    name="branchProject"
                    selectedOptions={branchProject}
                    classDiv="relative w-full inline-block"
                    onChange={brangeChange}
                    classLabel={mainTable.labelNoWrap}
                  />
                  {branchProjectError && (
                    <span className="text-red-500">{branchProjectError}</span>
                  )}
                </div>
              )}
              {(userProfileDatas[0]?.MstOrganizationId == 2 ||
                userProfileDatas[0]?.MstOrganizationId == 3) && (
                  <InputText
                    inputType="text"
                    title="Branch/Project"
                    classStar="text-red-500"
                    name="schoolName"
                    disabled="true"
                    content={branchName}
                    controlFunc={(e) => setBranchName(e.target.value)}
                  />
                )}
              <div>
                <MultiSelect
                  classStar="text-red-500"
                  label="SDP"
                  filteredOptions={bindSDP}
                  classFilterLabel="p-1 flex gap-1"
                  class="custom-class"
                  placeholder={sdp?.length > 0 ? "More Selected" : "Select..."}
                  name="sdp"
                  selectedOptions={sdp}
                  classDiv="relative w-full inline-block"
                  onChange={sdpChange}
                  classLabel={mainTable.labelNoWrap}
                />
                {sdpError && <span className="text-red-500">{sdpError}</span>}
              </div>

              <div>
                <MultiSelect
                  classStar="text-red-500"
                  label="Area"
                  filteredOptions={bindArea}
                  classFilterLabel="p-1 flex gap-1"
                  class="custom-class"
                  placeholder={area?.length > 0 ? "More Selected" : "Select..."}
                  name="area"
                  selectedOptions={area}
                  classDiv="relative w-full inline-block"
                  onChange={areaChange}
                  classLabel={mainTable.labelNoWrap}
                />
                {areaError && <span className="text-red-500">{areaError}</span>}
              </div>
            </div>
            <div class={mainTable.grid3}>
              <AutoDropDown
                // classStar="text-red-500"
                title="Project"
                options={bindProject}
                placeholder="Select"
                name="project"
                disabled={false}
                selectedOption={bindProject?.find(
                  (x) => x.value === project
                )}
                controlFunc={(value) => {
                  setProject(value.value);
                  setProjectError(""); // clear error on change
                }}
                controlFuncBlur={() => {
                  setProjectError(project ? "" : "Select Project");
                }}
                Class="custom-class"
                tabIndex={1}
                // errorMessage={projectError}
              />
              <InputText
                inputType="date"
                title="From"
                name="fromDate"
                content={fromDate}
                controlFunc={(e) => setFromDate(e.target.value)}
              />
              <InputText
                inputType="date"
                title="To"
                name="toDate"
                content={toDate}
                controlFunc={(e) => setToDate(e.target.value)}
              />
              {/* <div class="flex justify-start items-center mt-6">
                <button
                  type="button"
                  onClick={() => GoButton()}
                  className={mainTable.addButton}
                >
                  GO
                </button>
              </div> */}
            </div>
            <div className={mainTable.grid3}>
              <div></div>
              <div className="flex justify-center items-center mt-6">
                <button
                  type="button"
                  onClick={GoButton}
                  className={mainTable.addButton}
                >
                  GO
                </button>
              </div>
            </div>
          </div>
        </div>
        {showTable &&
          (bindProfileCATClientsData.length > 0 ? (
            <div className=" ">
              <ReportRowRowPage
                title=""
                header={ProfileCATClientsReportHeader}
                records={bindProfileCATClientsData}
                handleExport={handleExport}
                handlePDF={downloadPDF}
                isGenderBased={false}
              />
            </div>
          ) : (
            <div className="flex items-center justify-center">
              No record found
            </div>
          ))}
      </div>
    </MainLayout>
  );
};

export default ProfileCATClientsReport;
